import { updateWorkflowStatus } from 'api/WorkflowsAPI';
import type { AppDispatch } from 'modules/app/components/App';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';

import { WorkflowIdData } from '../types';
import { TOGGLE_MODAL_TYPE } from '../constants';

const displayText = {
  singular: {
    enabled: 'Successfully enabled journey',
    disabled: 'Successfully disabled journey',
    enableError: 'Could not enable journey',
    disableError: 'Could not disable journey',
  },
  bulk: {
    enabled: 'Successfully enabled journeys',
    disabled: 'Successfully disabled journeys',
    enableError: 'Could not enable journeys',
    disableError: 'Could not disable journeys',
  },
};

export const toggleWorkflows = async (
  workflows: WorkflowIdData[],
  toggleType: TOGGLE_MODAL_TYPE,
  dispatch: AppDispatch,
) => {
  const displayTextForWorkflows = workflows.length === 1 ? displayText.singular : displayText.bulk;
  const enabled = toggleType === TOGGLE_MODAL_TYPE.ENABLE;
  try {
    await updateWorkflowStatus(
      workflows.map(({ id }) => id),
      enabled,
    );
    dispatch(
      addPositiveToast(
        enabled ? displayTextForWorkflows.enabled : displayTextForWorkflows.disabled,
      ),
    );
  } catch (e) {
    dispatch(
      addNegativeToastWithErrorId(
        enabled ? displayTextForWorkflows.enableError : displayTextForWorkflows.disableError,
        'toggleWorkflows',
      ),
    );
  }
};
